"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Caption = function Caption(_ref) {
  var variant = _ref.variant,
      classNameProp = _ref.className,
      children = _ref.children;
  var className = (0, _clsx["default"])('oui-caption', {
    'oui-font-bold': variant == 'bold',
    'oui-font-medium': variant == 'medium',
    'oui-font-regular': variant == 'regular',
    'oui-font-light': variant == 'light'
  }, classNameProp);
  return /*#__PURE__*/_react["default"].createElement("p", {
    className: className
  }, children);
};

Caption.propTypes = {
  variant: _propTypes["default"].oneOf(['bold', 'medium', 'regular', 'light']),
  className: _propTypes["default"].string,
  children: _propTypes["default"].node
};
Caption.defaultProps = {
  variant: 'regular',
  className: '',
  children: ''
};
var _default = Caption;
exports["default"] = _default;